<div class="grid-container">
  <div class="grid-x">
    <div class="cell error-wrapper text-center">
      <h1 [innerHTML]="'errorpage.noresult.headline' | translate"></h1>
      <p [innerHTML]="'errorpage.noresult.text' | translate"></p>
      <button [innerHTML]="'errorpage.noresult.button' | translate" class="button primary" [routerLink]=restartAdvisor></button>
    </div>
  </div>
</div>
